import { RouteObject } from 'react-router-dom';
import { SignalAgentsRemote } from 'components/pages/signal-agents-remote';

export const signalAgentsRoutes: RouteObject[] = [
    {
        path: '/signal-agents/*',
        element: <SignalAgentsRemote />,
    },
];
